export default __webpack_public_path__ + "static/media/4.25cea742.webp";